import * as types from './mutation-types';

const state = {
  stormPool: null,
  stormSession: {},
  allUsers: [],
  mappedStormUsers: {},
  allTickets: [],
  stormUsers: [],
  userEvents: [],
  chosenUser: {},
  stormUser: {},
  eventUser: {
    email: null,
    picture: null,
  },
};

const getters = {
  stormPool(state) {
    return state.stormPool;
  },
  stormSession(state) {
    return state.stormSession;
  },
  allUsers(state) {
    return state.allUsers;
  },
  allTickets(state) {
    return state.allTickets;
  },
  stormUsers(state) {
    return state.stormUsers;
  },
  mappedStormUsers(state) {
    return state.mappedStormUsers;
  },
  chosenUser(state) {
    return state.chosenUser;
  },
  stormUser(state) {
    return state.stormUser;
  },
  userEvents(state) {
    return state.userEvents;
  },
  eventUser(state) {
    return state.eventUser;
  },
};

const mutations = {
  [types.SET_STORM_POOL](state, p) {
    state.stormPool = p;
  },
  [types.SET_STORM_SESSION](state, p) {
    state.stormSession = p.session;
  },
  [types.SET_ALL_USERS](state, p) {
    state.allUsers = p;
  },
  [types.SET_ALL_TICKETS](state, p) {
    state.allTickets = p;
  },
  [types.SET_ALL_STORM_USERS](state, p) {
    state.stormUsers = p;
    p.forEach((user) => {
      const mapItem = {};
      user.Attributes.forEach((attr) => {
        if (attr.Name.match(/^custom:/)) {
          mapItem[attr.Name.replace(/^custom:/gi, '')] = attr.Value;
        } else {
          mapItem[attr.Name] = attr.Value;
        }
      });
      state.mappedStormUsers[user.Username] = mapItem;
    });
  },
  [types.SET_CHOSEN_USER](state, p) {
    state.chosenUser = p;
  },
  [types.UPDATE_CHOSEN_USER](state, p) {
    state.chosenUser[p.key] = p.value;
  },
  [types.SET_STORM_USER](state, p) {
    state.stormUser = p;
  },
  [types.SET_USER_EVENTS](state, p) {
    state.userEvents = p;
  },
  [types.SET_EVENT_USER](state, p) {
    state.eventUser.email = p.email;
    state.eventUser.picture = p.picture;
    state.eventUser.created = p.created;
  },
  [types.REMOVE_STORM_USER](state, p) {
    const index = state.allUsers.findIndex(user => user.Username === p.sub);
    if (index > -1) {
      state.allUsers.splice(index, 1);
    }
  },
  [types.REMOVE_INTERNAL_USER](state, p) {
    const index = state.stormUsers.findIndex(user => user.Username === p.sub);
    if (index > -1) {
      state.stormUsers.splice(index, 1);
    }
  },
  [types.ADD_STORM_USER](state, user) {
    state.stormUsers.splice(0, 0, user);
    const mapItem = {};
    user.Attributes.forEach((attr) => {
      if (attr.Name.match(/^custom:/)) {
        mapItem[attr.Name.replace(/^custom:/gi, '')] = attr.Value;
      } else {
        mapItem[attr.Name] = attr.Value;
      }
    });
    state.mappedStormUsers[user.Username] = mapItem;
  },
};

const actions = {
  setStormPool: ({ commit }, p) => commit(types.SET_STORM_POOL, p),
  setStormSession: ({ commit }, p) => commit(types.SET_STORM_SESSION, p),
  setAllUsers: ({ commit }, p) => commit(types.SET_ALL_USERS, p),
  setAllTickets: ({ commit }, p) => commit(types.SET_ALL_TICKETS, p),
  setStormUsers: ({ commit }, p) => commit(types.SET_ALL_STORM_USERS, p),
  setChosenUser: ({ commit }, p) => commit(types.SET_CHOSEN_USER, p),
  updateChosenUser: ({ commit }, p) => commit(types.UPDATE_CHOSEN_USER, p),
  setStormUser: ({ commit }, p) => commit(types.SET_STORM_USER, p),
  setUserEvents: ({ commit }, p) => commit(types.SET_USER_EVENTS, p),
  setEventUser: ({ commit }, p) => commit(types.SET_EVENT_USER, p),
  removeStormUser: ({ commit }, p) => commit(types.REMOVE_STORM_USER, p),
  removeInternalUser: ({ commit }, p) => commit(types.REMOVE_INTERNAL_USER, p),
  addStormUser: ({ commit }, p) => commit(types.ADD_STORM_USER, p),
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/storm/store/vuex.js